export default __webpack_public_path__ + "static/media/02.a71cff5b.png";